import Action from './Notification/Action.es6';

(function() {
    class Notification extends App.Entities.Notifications {
        constructor() {
            super();
            this
                .setDefaultContainer('page-top')
                .addPosition('site-top') // over the header
                .addPosition('page-top') // on content start
                .addPosition('page-bottom') // on content end
            ;

            if (App.Variable('notificationMsg')) {
                this.add('floating', App.Variable('notificationMsg')).update();
            }
            this.bind();
        }

        get Action() { return this._action || (this._action = new Action(this)) }

        /**
         * Get Position (with container) to render
         * @param name
         * @return {*}
         */
        getPosition(name) {
            if (this.positions[name])
                if (this.positions[name].container !== null)
                    if (this.positions[name].container.container instanceof Node)
                        if (!document.body.contains(this.positions[name].container.container))
                            delete this.positions[name];
            return this.positions[name];
        }

        /**
         * Add a position where notification will be shown
         * @param name
         * @param container This can be a jQuery Element or a Component with a "handleNotifications" method
         * @return {Notification}
         */
        addPosition(name, container = null) {
            if (!('positions' in this)) this.positions = {};
            this.positions[name] = {
                container: null,
            };
            this.updatePosition(name, 'container', container);
            return this;
        }

        /**
         * Update a already given position (container)
         * @param name
         * @param key
         * @param value
         * @return {Notification}
         */
        updatePosition(name, key, value) {
            this.positions[name][key] = value;
            return this;
        }

        /**
         * Empty bundle of notification (for re-render)
         * @return {Notification}
         */
        reset() {
            super.reset();
            this.emptyContainers();
            this.update(false);
            return this;
        }

        /**
         * Create a position (container) in DOM to display notifications
         * @param position
         * @return {Notification}
         */
        build(position) {
            let container = App.Template.parse('notification-container', {position: position}, true);
            switch (position) {
                case 'page-top':
                    $(App.Layout.main).prepend(container);
                    this.updatePosition(position, 'container', container);
                    break;
                case 'site-top':
                    App.Layout.body.prepend(container);
                    this.updatePosition(position, 'container', container);
                    break;
                case 'page-bottom':
                    $(App.Layout.main).after(container);
                    this.updatePosition(position, 'container', container);
                    break;
                default:
                    break;
            }
            return this;
        }

        /**
         * Returns the a notification template
         * @param notification (Model)
         * @return {The}
         */
        renderNotification(notification) {
            return App.Template.parse('notification', notification);
        }

        /**
         * Empty position (containers)
         * @return {Notification}
         */
        emptyContainers() {
            for (let position in this.positions) {
                if (this.getPosition(position) === undefined) continue;
                let container = this.getPosition(position).container;
                if (container !== null && container.html) container.html('');
            }
            return this;
        }

        /**
         * Scroll to first possible notification
         */
        scrollToFirstNotification() {
            let timeout = setTimeout(() => {
                let notification = App.Layout.body.find('.notification[data-type="error"], .form-group[data-status="error"]').first();
                if (notification.length) {
                    clearTimeout(this.timeout);
                    this.timeout = timeout;
                    App.Layout.setPosition(notification.offset().top - App.Layout.top);
                }
            }, App.Setting('FX_DURATION_SHORT'));
        }

        /* Set a bundle coming from the API or an URL request */
        setFromBundle(notifications) {
            this.reset();
            /* Set Notifications */
            for (let position in notifications) {
                let bundle = notifications[position];
                position = this.getPosition(position) ? position : this.defaultContainerName;
                if (this.isComponent(position)) {
                    this.setComponentBundle(position, bundle);
                } else {
                    for (let key in bundle) {
                        let notification = bundle[key];
                        if (notification.message && notification.type)
                            this.add(
                                position,
                                notification.message,
                                notification.type,
                                notification.icon || true,
                                notification.close || null,
                                notification.layout || 'standard',
                                notification.timer || 0,
                                notification.title || '',
                                notification.action || ''
                            );
                    }
                }
            }
            this.update();
        }

        /**
         * Check if position is component or a container
         * @param position
         * @return {boolean}
         */
        isComponent(position) {
            if (this.getPosition(position) === undefined) return false;
            if (this.getPosition(position).container === undefined) return false;
            return this.getPosition(position).container instanceof App.Component;
        }

        /**
         * In case the position is a component it will
         * send the bundle to the component for handling
         *
         * @param position
         * @param bundle
         * @return {Notification}
         */
        setComponentBundle(position, bundle) {
            // Handle Component notifications
            let Comp = this.getPosition(position);
            if (Comp !== undefined)
                if (Comp.container.handleNotifications !== undefined)
                    Comp.container.handleNotifications(bundle);
            return this;
        }

        /**
         * Reuse old jQuery notification library
         *
         * notificationFx.js v1.0.0
         * http://www.codrops.com
         */
        renderFloatingNotifications(notifications) {
            let dismiss = template => {
                clearTimeout(template.dismissttl);
                template
                    .removeClass('ns-show').addClass('ns-hide')
                    .on('animationend', e => template.remove())
                ;
            };
            notifications.forEach((notification, index) => {
                const template = App.Template.parse('notification-floating', notification.message, 'jquery');
                $('body').append(template);
                let timeOut = template => setTimeout(() => dismiss(template), App.Setting('FX_DURATION_EXTRA_LONG'));
                template
                    .removeClass('ns-hide').addClass('ns-show')
                    .mouseover(e => clearTimeout(template.dismissttl))
                    .mouseout(e => template.dismissttl = timeOut(template))
                    .dismissttl = timeOut(template)
                ;
            });
            // top position for all active notifications
            let offset = 0;
            $('.js-floating-notification').each((index, element) => {
                $(element).css('top', offset + 'px');
                offset += $(element).outerHeight() + 20;
            });
            // empty floating queue
            this.notifications['floating'] = [];

        }

        bind() {
            // Close floating notification
            $(document).on('click', '.ns-close', function() {
                const parent = $(this).parent();
                parent.removeClass('ns-show').addClass('ns-hide')
                    .on('animationend', e => parent.remove())
                ;
            });
        }

        update(scroll = true) {
            let notifications = this.get();
            for (let position in notifications) {
                switch (position) {
                    case 'floating':
                        this.renderFloatingNotifications(notifications[position]);
                        break;
                    default:
                        this.getPosition(position).container === null ? this.build(position) : this.getPosition(position).container.html('');
                        notifications[position].forEach((notification, index) => {
                            // Render and run action to notification
                            this.getPosition(position).container.append(this.renderNotification(notification));
                            if (notification.action) {
                                const action = this.Action.get(notification.action);
                                if (action) action();
                            }

                            if (notification.timer > 0) {
                                setTimeout(() => {
                                    this.remove(position, index).update();
                                }, notification.timer);
                            }
                        });
                }
            }
            App.Components.applyBySelector('.notification');
            if (scroll) {
                this.scrollToFirstNotification();
            }
            return this;
        }
    }
    App.Interface.Notification = new Notification();
})();
